module.exports = __webpack_public_path__ + "img/East_Ayrshire.d46d6ff0.png";